import React, { useEffect, useState } from 'react';
import styles from './Date.module.scss';
import { localeMoment } from '../../../utils/moment';
import { useSelector } from 'react-redux';

export default function HeaderDate() {
    const locale = useSelector(state => state.settings.locale);
    const [currentTime, setCurrentTime] = useState(null);

    useEffect(() => {
        const timer = setInterval(() => {
            startCurrentTime();
        }, 1000);

        return () => {
            clearInterval(timer);
        };
    }, []);

    const startCurrentTime = () => {
        const date = localeMoment()(new Date());
        setCurrentTime(date.format('HH:mm:ss'));
    };

    return (
        <>
            <div className={styles.date}>
                <i className='icon-event' />
                <span className={styles.text}>
                    {localeMoment(locale)().format('MMM DD ddd, YYYY')}
                </span>
            </div>
            <div className={`${styles.date} center w-40`}>
                <i className='icon-clock' />
                <span className={styles.text}>{currentTime}</span>
            </div>
        </>
    );
}
